import { render, staticRenderFns } from "./blockPricing.vue?vue&type=template&id=6f9ea8da&scoped=true&"
import script from "./blockPricing.vue?vue&type=script&lang=js&"
export * from "./blockPricing.vue?vue&type=script&lang=js&"
import style0 from "./blockPricing.vue?vue&type=style&index=0&id=6f9ea8da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9ea8da",
  null
  
)

export default component.exports